import * as $ from 'jquery'
import * as _ from 'lodash'

class Countdown {
  public $element: any
  constructor(element: Node) {
    this.$element = $(element)
  }

  build() {
    const remaining = this.$element.data('remaining')
    this.tick()
  }

  tick() {
    const remaining = this.$element.data('remaining')
    if (remaining <= 0) {
      this.fire()
    } else {
      this.update()
      this.$element.data('remaining', remaining - 1)
      setTimeout(this.tick.bind(this), 1000)
    }
  }

  update() {
    const remaining = this.$element.data('remaining') - 1
    const label = this.$element.data("countdown-label")
    const html = _.template(label)({ remaining })
    this.$element.html(html)
  }

  fire() {
    const label = this.$element.data("fire-label")
    this.$element.removeClass('disabled').text(label)
  }
}

function initCountdown(root: Node) {
  if ($(root).is(".countdown")) {
    new Countdown(root).build()
  } else {
    $(root).find(".countdown").each(function() {
      new Countdown(this).build()
    })
  }
}

$(function() {
  initCountdown(document)
  $(document).on("content:loaded", function(event) {
    initCountdown(event.target)
  })
})
